import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';
import { TUserMeta, TUserMetaResponse, adaptUserMetaUndefinedFromResponse } from './user-meta.type';
import { TListResponse } from 'src/common/types';


export const UserClientContactListSortCol = {
	ID: 'id',
	NAME: 'name',
	POSITION: 'position',
	PHONE_NUMBER: 'phone_number',
	EMAIL: 'email',
	UPDATED_AT: 'updated_at',
	CREATED_AT: 'created_at',
};

export type TUserClientContactListSortCol = TTableSortCols<typeof UserClientContactListSortCol>;

export type TUserClientContactListQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TUserClientContactListSortCol;
};

export type TUserClientContactQueryPayload = {
	clientId: number;
	data?: TUserClientContactListQuery;
};

export type TUserClientContactQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptUserClientContactQueryToRequest(data: TUserClientContactListQuery): TUserClientContactQueryRequest {
	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TUserClientContact = {
  id: number;
  clientId: number;
  description?: string;
  phoneNumber?: string;
  email?: string;
	createdAt: string;
  updatedAt: string;

	createdBy?: TUserMeta;
	updatedBy?: TUserMeta;
};

export type TUserClientContactResponse = {
  id: number;
  client_id: number;
  description?: string;
  phone_number?: string;
	email?: string;
  created_at: string;
  updated_at: string;

	created_by: TUserMetaResponse;
	updated_by: TUserMetaResponse;
};

export type TUserClientContactListResponse = TListResponse<TUserClientContactResponse>;

export type TUserClientContactList = TListResponse<TUserClientContact>;

export type TUserClientContactBodyRequest = {
	description?: string;
	phoneNumber?: string;
	email?: string;
};

export type TUserClientContactRequest = {
	description?: string;
	phone_number?: string;
	email?: string;
};

export type TUserClientContactPayloadParams = {
	id: number;
	clientId: number;
};

export type TUserClientContactPayloadCreate = {
	clientId: number;
	data: TUserClientContactBodyRequest;
};

export type TUserClientContactPayloadUpdate = TUserClientContactPayloadCreate & {
	id: number;
};

export function adaptUserClientContactFromListResponse(data: TUserClientContactListResponse): TUserClientContactList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptUserClientContactFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptUserClientContactFromResponse(data: TUserClientContactResponse): TUserClientContact {
	const {
		id,
		client_id: clientId,
		description,
		phone_number: phoneNumber,
		email,
		created_by: createdByRaw,
		updated_by: updatedByRaw,
		created_at: createdAt,
		updated_at: updatedAt,
	} = data;

	const createdBy = adaptUserMetaUndefinedFromResponse(createdByRaw);
	const updatedBy = adaptUserMetaUndefinedFromResponse(updatedByRaw);

	return {
		id,
		clientId,
		description,
		phoneNumber,
		email,
		createdBy,
		updatedBy,
		createdAt,
		updatedAt,
	};
}

export function adaptUserClientContactToRequest(data: TUserClientContactBodyRequest): TUserClientContactRequest {
	const {
		description = undefined,
		phoneNumber = undefined,
		email = undefined,
	} = data;

	return {
		description,
		phone_number: phoneNumber,
		email,
	};
}
